(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~menu~popconfirm~popover~slider~tooltip"],{

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/base/vc-trigger/index.js + 9 modules
var vc_trigger = __webpack_require__(25);

// CONCATENATED MODULE: ./src/base/vc-tooltip/placements.js
var placements_autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: placements_autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: placements_autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: placements_autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: placements_autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: placements_autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: placements_autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};
/* harmony default export */ var vc_tooltip_placements = (placements);
// CONCATENATED MODULE: ./src/base/vc-tooltip/Content.jsx

/* harmony default export */ var Content = ({
  props: {
    prefixCls: vue_types["a" /* default */].string,
    overlay: vue_types["a" /* default */].any,
    trigger: vue_types["a" /* default */].any
  },
  updated: function updated() {
    var trigger = this.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  },
  render: function render() {
    var h = arguments[0];
    var overlay = this.overlay,
        prefixCls = this.prefixCls;
    return h("div", {
      "class": "".concat(prefixCls, "-inner"),
      attrs: {
        role: "tooltip"
      }
    }, [typeof overlay === 'function' ? overlay() : overlay]);
  }
});
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// CONCATENATED MODULE: ./src/base/vc-tooltip/Tooltip.jsx
var _excluded = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







function noop() {}

/* harmony default export */ var Tooltip = ({
  props: {
    trigger: vue_types["a" /* default */].any.def(['hover']),
    defaultVisible: vue_types["a" /* default */].bool,
    visible: vue_types["a" /* default */].bool,
    placement: vue_types["a" /* default */].string.def('right'),
    transitionName: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].object]),
    animation: vue_types["a" /* default */].any,
    afterVisibleChange: vue_types["a" /* default */].func.def(function () {}),
    overlay: vue_types["a" /* default */].any,
    overlayStyle: vue_types["a" /* default */].object,
    overlayClassName: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string.def('rc-tooltip'),
    mouseEnterDelay: vue_types["a" /* default */].number.def(0),
    mouseLeaveDelay: vue_types["a" /* default */].number.def(0.1),
    getTooltipContainer: vue_types["a" /* default */].func,
    destroyTooltipOnHide: vue_types["a" /* default */].bool.def(false),
    align: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    arrowContent: vue_types["a" /* default */].any.def(null),
    tipId: vue_types["a" /* default */].string,
    builtinPlacements: vue_types["a" /* default */].object
  },
  methods: {
    getPopupElement: function getPopupElement() {
      var h = this.$createElement;
      var _this$$props = this.$props,
          prefixCls = _this$$props.prefixCls,
          tipId = _this$$props.tipId;
      return [h("div", {
        "class": "".concat(prefixCls, "-arrow"),
        key: "arrow"
      }, [Object(props_util["getComponentFromProp"])(this, 'arrowContent')]), h(Content, {
        key: "content",
        attrs: {
          trigger: this.$refs.trigger,
          prefixCls: prefixCls,
          id: tipId,
          overlay: Object(props_util["getComponentFromProp"])(this, 'overlay')
        }
      })];
    },
    getPopupDomNode: function getPopupDomNode() {
      return this.$refs.trigger.getPopupDomNode();
    }
  },
  render: function render(h) {
    var _getOptionProps = Object(props_util["getOptionProps"])(this),
        overlayClassName = _getOptionProps.overlayClassName,
        trigger = _getOptionProps.trigger,
        mouseEnterDelay = _getOptionProps.mouseEnterDelay,
        mouseLeaveDelay = _getOptionProps.mouseLeaveDelay,
        overlayStyle = _getOptionProps.overlayStyle,
        prefixCls = _getOptionProps.prefixCls,
        afterVisibleChange = _getOptionProps.afterVisibleChange,
        transitionName = _getOptionProps.transitionName,
        animation = _getOptionProps.animation,
        placement = _getOptionProps.placement,
        align = _getOptionProps.align,
        destroyTooltipOnHide = _getOptionProps.destroyTooltipOnHide,
        defaultVisible = _getOptionProps.defaultVisible,
        getTooltipContainer = _getOptionProps.getTooltipContainer,
        restProps = _objectWithoutProperties(_getOptionProps, _excluded);

    var extraProps = _objectSpread({}, restProps);

    if (Object(props_util["hasProp"])(this, 'visible')) {
      extraProps.popupVisible = this.$props.visible;
    }

    var listeners = Object(props_util["getListeners"])(this);
    var triggerProps = {
      props: _objectSpread({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        action: trigger,
        builtinPlacements: placements,
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      on: _objectSpread(_objectSpread({}, listeners), {}, {
        popupVisibleChange: listeners.visibleChange || noop,
        popupAlign: listeners.popupAlign || noop
      }),
      ref: 'trigger'
    };
    return h(vc_trigger["a" /* default */], triggerProps, [h("template", {
      slot: "popup"
    }, [this.getPopupElement(h)]), this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-tooltip/index.js
// based on rc-tooltip 3.7.3

/* harmony default export */ var vc_tooltip = (Tooltip);
// CONCATENATED MODULE: ./src/components/tooltip/placements.js
function placements_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function placements_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { placements_ownKeys(Object(source), true).forEach(function (key) { placements_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { placements_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function placements_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var placements_targetOffset = [0, 0];
function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }

  return placements_objectSpread(placements_objectSpread({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}
function placements_getPlacements(config) {
  var _config$arrowWidth = config.arrowWidth,
      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
      _config$horizontalArr = config.horizontalArrowShift,
      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
      _config$verticalArrow = config.verticalArrowShift,
      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
      _config$autoAdjustOve = config.autoAdjustOverflow,
      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-4, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [4, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -4]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, 4]
    },
    topLeft: {
      points: ['bl', 'tc'],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ['tr', 'cl'],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ['br', 'tc'],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ['tl', 'cr'],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ['tr', 'bc'],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ['bl', 'cr'],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ['tl', 'bc'],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ['br', 'cl'],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? placements_objectSpread(placements_objectSpread({}, placementMap[key]), {}, {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: placements_targetOffset
    }) : placements_objectSpread(placements_objectSpread({}, placements[key]), {}, {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
    placementMap[key].ignoreShake = true;
  });
  return placementMap;
}
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// EXTERNAL MODULE: ./src/components/tooltip/abstractTooltipProps.js
var abstractTooltipProps = __webpack_require__(70);

// CONCATENATED MODULE: ./src/components/tooltip/Tooltip.jsx
function Tooltip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Tooltip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Tooltip_ownKeys(Object(source), true).forEach(function (key) { Tooltip_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Tooltip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Tooltip_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var splitObject = function splitObject(obj, keys) {
  var picked = {};

  var omitted = Tooltip_objectSpread({}, obj);

  keys.forEach(function (key) {
    if (obj && key in obj) {
      picked[key] = obj[key];
      delete omitted[key];
    }
  });
  return {
    picked: picked,
    omitted: omitted
  };
};

var props = Object(abstractTooltipProps["a" /* default */])();
/* harmony default export */ var tooltip_Tooltip = ({
  name: "MegTooltip",
  model: {
    prop: "visible",
    event: "visibleChange"
  },
  props: Tooltip_objectSpread(Tooltip_objectSpread({}, props), {}, {
    title: vue_types["a" /* default */].any
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    return {
      sVisible: !!this.$props.visible || !!this.$props.defaultVisible
    };
  },
  watch: {
    visible: function visible(val) {
      this.sVisible = val;
    }
  },
  methods: {
    onVisibleChange: function onVisibleChange(visible) {
      if (!Object(props_util["hasProp"])(this, "visible")) {
        this.sVisible = this.isNoTitle() ? false : visible;
      }

      if (!this.isNoTitle()) {
        this.$emit("visibleChange", visible);
      }
    },
    getPopupDomNode: function getPopupDomNode() {
      return this.$refs.tooltip.getPopupDomNode();
    },
    getPlacements: function getPlacements() {
      var _this$$props = this.$props,
          builtinPlacements = _this$$props.builtinPlacements,
          arrowPointAtCenter = _this$$props.arrowPointAtCenter,
          autoAdjustOverflow = _this$$props.autoAdjustOverflow;
      return builtinPlacements || placements_getPlacements({
        arrowPointAtCenter: arrowPointAtCenter,
        verticalArrowShift: 8,
        autoAdjustOverflow: autoAdjustOverflow
      });
    },
    // Fix Tooltip won't hide at disabled button
    // mouse events don't trigger at disabled button in Chrome
    // https://github.com/react-component/tooltip/issues/18
    getDisabledCompatibleChildren: function getDisabledCompatibleChildren(ele) {
      var h = this.$createElement;
      var options = ele.componentOptions && ele.componentOptions.Ctor.options || {};
      var compatibleKey = "MegButton"; // fix 组件btn & 原生btn disabled

      if (options.name === compatibleKey && ele.componentOptions && ele.componentOptions.propsData && ele.componentOptions.propsData.disabled || ele.tag === "button" && ele.data && ele.data.attrs && ele.data.attrs.disabled !== undefined) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = splitObject(Object(props_util["getStyle"])(ele), ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]),
            picked = _splitObject.picked,
            omitted = _splitObject.omitted; // default inline-block is important


        var spanStyle = Tooltip_objectSpread(Tooltip_objectSpread({
          display: "inline-block"
        }, picked), {}, {
          cursor: "not-allowed",
          width: ele.componentOptions && ele.componentOptions.propsData && ele.componentOptions.propsData.block ? "100%" : null
        });

        var buttonStyle = Tooltip_objectSpread(Tooltip_objectSpread({}, omitted), {}, {
          pointerEvents: "none"
        });

        var spanCls = Object(props_util["getClass"])(ele);
        var child = Object(vnode["a" /* cloneElement */])(ele, {
          style: buttonStyle,
          class: null
        });
        return h("span", {
          style: spanStyle,
          "class": spanCls
        }, [child]);
      }

      return ele;
    },
    isNoTitle: function isNoTitle() {
      var title = Object(props_util["getComponentFromProp"])(this, "title");
      return !title && title !== 0;
    },
    getOverlay: function getOverlay() {
      var title = Object(props_util["getComponentFromProp"])(this, "title");

      if (title === 0) {
        return title;
      }

      return title || "";
    },
    // 动态设置动画点
    onPopupAlign: function onPopupAlign(domNode, align) {
      var placements = this.getPlacements(); // 当前返回的位置

      var placement = Object.keys(placements).filter(function (key) {
        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
      })[0];

      if (!placement) {
        return;
      } // 根据当前坐标设置动画点


      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: "50%",
        left: "50%"
      };

      if (placement.indexOf("top") >= 0 || placement.indexOf("Bottom") >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf("Top") >= 0 || placement.indexOf("bottom") >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }

      if (placement.indexOf("left") >= 0 || placement.indexOf("Right") >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf("right") >= 0 || placement.indexOf("Left") >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }

      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
      var offset = this.$props.offset; // 设置topOffset 和 leftOffset

      domNode.style.top = "".concat(parseFloat(domNode.style.top.replace('px', '')) - offset[0], "px");
      domNode.style.left = "".concat(parseFloat(domNode.style.left.replace('px', '')) - offset[1], "px");
    }
  },
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        $data = this.$data,
        $slots = this.$slots;
    var customizePrefixCls = $props.prefixCls,
        openClassName = $props.openClassName,
        getPopupContainer = $props.getPopupContainer;
    var getContextPopupContainer = this.configProvider.getPopupContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    var children = ($slots.default || []).filter(function (c) {
      return c.tag || c.text.trim() !== "";
    });
    children = children.length === 1 ? children[0] : children;
    var sVisible = $data.sVisible; // Hide tooltip when there is no title

    if (!Object(props_util["hasProp"])(this, "visible") && this.isNoTitle()) {
      sVisible = false;
    }

    if (!children) {
      return null;
    }

    var child = this.getDisabledCompatibleChildren(Object(props_util["isValidElement"])(children) ? children : h("span", [children]));

    var childCls = Tooltip_defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true);

    var tooltipProps = {
      props: Tooltip_objectSpread(Tooltip_objectSpread({}, $props), {}, {
        prefixCls: prefixCls,
        getTooltipContainer: getPopupContainer || getContextPopupContainer,
        builtinPlacements: this.getPlacements(),
        overlay: this.getOverlay(),
        visible: sVisible
      }),
      ref: "tooltip",
      on: Tooltip_objectSpread(Tooltip_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
        visibleChange: this.onVisibleChange,
        popupAlign: this.onPopupAlign
      })
    };
    return h(vc_tooltip, tooltipProps, [sVisible ? Object(vnode["a" /* cloneElement */])(child, {
      class: childCls
    }) : child]);
  }
});
// EXTERNAL MODULE: ./src/directives/index.js + 3 modules
var directives = __webpack_require__(46);

// CONCATENATED MODULE: ./src/components/tooltip/index.jsx
 // import Base from '../base';


/* istanbul ignore next */

tooltip_Tooltip.install = function (Vue) {
  // Vue.use(Base);
  Vue.use(directives["a" /* default */]);
  Vue.component(tooltip_Tooltip.name, tooltip_Tooltip);
};

/* harmony default export */ var tooltip = __webpack_exports__["default"] = (tooltip_Tooltip);

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);

var triggerType = utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['hover', 'focus', 'click', 'contextmenu']);
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    trigger: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([triggerType, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(triggerType)]).def('hover'),
    visible: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
    defaultVisible: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
    placement: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['top', 'left', 'right', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom']).def('top'),
    color: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
    transitionName: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string.def('meg-tooltip-zoom'),
    // default transition name
    // onVisibleChange: PropTypes.func,
    overlayStyle: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object.def(function () {
      return {};
    }),
    overlayClassName: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
    prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
    mouseEnterDelay: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(0.1),
    mouseLeaveDelay: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(0.1),
    getPopupContainer: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
    arrowPointAtCenter: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(false),
    autoAdjustOverflow: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object]).def(true),
    destroyTooltipOnHide: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(false),
    align: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object.def(function () {
      return {};
    }),
    builtinPlacements: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object,
    offset: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].array.def([0, 0])
  };
});

/***/ })

}]);